import { css } from "@compiled/react";
import { useIntl } from "react-intl";

import { JiraLogo } from "@atlaskit/logo";

import AccountCreation from "@/components/signup/account-creation";
import {
    JiraOverlayTemplate,
    SignupBackgroundLayout
} from "@/components/signup/layouts";
import { wacToken } from "@/libraries/design/foundations";
import { experiments, ExperimentView } from "@/utils/experiment";
import { FeatureExposed } from "@/utils/feature-exposed";

import { InputSubmitButton, GetStartedHeading } from "../../../components";

export const LoggedOutJiraFree = () => (
    <ExperimentView
        experiment={experiments.jfindSignUpFlowOverlay}
        render={(value) =>
            value ? (
                <JiraOverlayTemplate size="sm">
                    <Content />
                </JiraOverlayTemplate>
            ) : (
                <SignupBackgroundLayout
                    ProductLogo={<JiraLogo size="xlarge" appearance="brand" />}
                >
                    <Content />
                </SignupBackgroundLayout>
            )
        }
    />
);

const Content = () => {
    const intl = useIntl();
    const subHeaderText = intl.formatMessage({
        id: "signupForm.accountCreation.subHeaderText",
        defaultMessage: "It’s free for up to 10 users - no credit card needed."
    });

    return (
        <>
            <GetStartedHeading productName="Jira" />
            <p css={subHeaderCss}>{subHeaderText}</p>
            <FeatureExposed
                experimentKey="jfind-1185-signup-button-update"
                group="Test"
            >
                <AccountCreation Input={<InputSubmitButton />} Submit={null} />
            </FeatureExposed>
        </>
    );
};
const subHeaderCss = css({
    color: wacToken("color.primary.black"),
    margin: "0 0 24px",
    textAlign: "center"
});
